import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'
import { orderSearchService } from '../services/order-search.service'
import type { Order } from '../types/order.type'

export function useFetchOrdersTransmissionQuery() {
  const {
    data: orders,
    isLoading: isLoadingOrdersTransmission,
    refetch: refetchOrdersTransmission,
  } = useQuery<Order[]>({
    queryKey: [QUERY_KEYS.ORDER_TRANSMISSION],
    queryFn: async () => {
      const response = await orderSearchService.searchInitialOrders({
        payload: {
          filters: [
            {
              filter: 'status',
              filterInput: 'AT',
              apiParam: 's.sigla'
            }
          ]
        }
      })
      return response.orders
    },
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnMount: 'always'
  })

  return {
    orders,
    isLoadingOrdersTransmission,
    refetchOrdersTransmission,
  }
}